import { Table as MantineTable } from "@mantine/core";
export function ShoesTable() {
  return (
    <MantineTable>
      <MantineTable.Thead>
        <MantineTable.Tr>
          <MantineTable.Th>EU (KURB)</MantineTable.Th>
          <MantineTable.Th>JP</MantineTable.Th>
          <MantineTable.Th>UK</MantineTable.Th>
          <MantineTable.Th>US/AU Mens</MantineTable.Th>
          <MantineTable.Th>US/AU Womans</MantineTable.Th>
          <MantineTable.Th>FR</MantineTable.Th>
        </MantineTable.Tr>
      </MantineTable.Thead>
      <MantineTable.Tbody>
        <MantineTable.Tr>
          <MantineTable.Td>35.5</MantineTable.Td>
          <MantineTable.Td>20.5</MantineTable.Td>
          <MantineTable.Td>2</MantineTable.Td>
          <MantineTable.Td>3</MantineTable.Td>
          <MantineTable.Td>4.5</MantineTable.Td>
          <MantineTable.Td>36.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>36</MantineTable.Td>
          <MantineTable.Td>21</MantineTable.Td>
          <MantineTable.Td>3</MantineTable.Td>
          <MantineTable.Td>3.5</MantineTable.Td>
          <MantineTable.Td>5</MantineTable.Td>
          <MantineTable.Td>37</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>36.5</MantineTable.Td>
          <MantineTable.Td>21.5</MantineTable.Td>
          <MantineTable.Td>2.5</MantineTable.Td>
          <MantineTable.Td>3.5</MantineTable.Td>
          <MantineTable.Td>5</MantineTable.Td>
          <MantineTable.Td>37.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>37</MantineTable.Td>
          <MantineTable.Td>22</MantineTable.Td>
          <MantineTable.Td>3</MantineTable.Td>
          <MantineTable.Td>4</MantineTable.Td>
          <MantineTable.Td>5.5</MantineTable.Td>
          <MantineTable.Td>38</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>37.5</MantineTable.Td>
          <MantineTable.Td>22.5</MantineTable.Td>
          <MantineTable.Td>3.5</MantineTable.Td>
          <MantineTable.Td>4.5</MantineTable.Td>
          <MantineTable.Td>6</MantineTable.Td>
          <MantineTable.Td>38.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>38</MantineTable.Td>
          <MantineTable.Td>23</MantineTable.Td>
          <MantineTable.Td>4</MantineTable.Td>
          <MantineTable.Td>5</MantineTable.Td>
          <MantineTable.Td>6.5</MantineTable.Td>
          <MantineTable.Td>39</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>38.5</MantineTable.Td>
          <MantineTable.Td>23.5</MantineTable.Td>
          <MantineTable.Td>4.5</MantineTable.Td>
          <MantineTable.Td>5.5</MantineTable.Td>
          <MantineTable.Td>7</MantineTable.Td>
          <MantineTable.Td>39.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>39</MantineTable.Td>
          <MantineTable.Td>24</MantineTable.Td>
          <MantineTable.Td>5</MantineTable.Td>
          <MantineTable.Td>6</MantineTable.Td>
          <MantineTable.Td>7.5</MantineTable.Td>
          <MantineTable.Td>40</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>39.5</MantineTable.Td>
          <MantineTable.Td>24.5</MantineTable.Td>
          <MantineTable.Td>5.5</MantineTable.Td>
          <MantineTable.Td>6.5</MantineTable.Td>
          <MantineTable.Td>8</MantineTable.Td>
          <MantineTable.Td>40.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>40</MantineTable.Td>
          <MantineTable.Td>25</MantineTable.Td>
          <MantineTable.Td>6</MantineTable.Td>
          <MantineTable.Td>7</MantineTable.Td>
          <MantineTable.Td>8.5</MantineTable.Td>
          <MantineTable.Td>41</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>40.5</MantineTable.Td>
          <MantineTable.Td>25.5</MantineTable.Td>
          <MantineTable.Td>6.5</MantineTable.Td>
          <MantineTable.Td>7.5</MantineTable.Td>
          <MantineTable.Td>9</MantineTable.Td>
          <MantineTable.Td>41.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>41</MantineTable.Td>
          <MantineTable.Td>26</MantineTable.Td>
          <MantineTable.Td>7</MantineTable.Td>
          <MantineTable.Td>8</MantineTable.Td>
          <MantineTable.Td>9.5</MantineTable.Td>
          <MantineTable.Td>42</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>41.5</MantineTable.Td>
          <MantineTable.Td>26.5</MantineTable.Td>
          <MantineTable.Td>7.5</MantineTable.Td>
          <MantineTable.Td>8.5</MantineTable.Td>
          <MantineTable.Td>10</MantineTable.Td>
          <MantineTable.Td>42.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>42</MantineTable.Td>
          <MantineTable.Td>27</MantineTable.Td>
          <MantineTable.Td>8</MantineTable.Td>
          <MantineTable.Td>9</MantineTable.Td>
          <MantineTable.Td>10.5</MantineTable.Td>
          <MantineTable.Td>43</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>42.5</MantineTable.Td>
          <MantineTable.Td>27.5</MantineTable.Td>
          <MantineTable.Td>8.5</MantineTable.Td>
          <MantineTable.Td>9.5</MantineTable.Td>
          <MantineTable.Td>11</MantineTable.Td>
          <MantineTable.Td>43.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>43</MantineTable.Td>
          <MantineTable.Td>28</MantineTable.Td>
          <MantineTable.Td>9</MantineTable.Td>
          <MantineTable.Td>10</MantineTable.Td>
          <MantineTable.Td>11.5</MantineTable.Td>
          <MantineTable.Td>44</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>43.5</MantineTable.Td>
          <MantineTable.Td>28.5</MantineTable.Td>
          <MantineTable.Td>9.5</MantineTable.Td>
          <MantineTable.Td>10.5</MantineTable.Td>
          <MantineTable.Td>12</MantineTable.Td>
          <MantineTable.Td>44.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>44</MantineTable.Td>
          <MantineTable.Td>29</MantineTable.Td>
          <MantineTable.Td>10</MantineTable.Td>
          <MantineTable.Td>11</MantineTable.Td>
          <MantineTable.Td>12.5</MantineTable.Td>
          <MantineTable.Td>45</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>44.5</MantineTable.Td>
          <MantineTable.Td>29.5</MantineTable.Td>
          <MantineTable.Td>10.5</MantineTable.Td>
          <MantineTable.Td>11.5</MantineTable.Td>
          <MantineTable.Td>13</MantineTable.Td>
          <MantineTable.Td>45.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>45</MantineTable.Td>
          <MantineTable.Td>30</MantineTable.Td>
          <MantineTable.Td>11</MantineTable.Td>
          <MantineTable.Td>12</MantineTable.Td>
          <MantineTable.Td>13.5</MantineTable.Td>
          <MantineTable.Td>46</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>45.5</MantineTable.Td>
          <MantineTable.Td>30.5</MantineTable.Td>
          <MantineTable.Td>11.5</MantineTable.Td>
          <MantineTable.Td>12.5</MantineTable.Td>
          <MantineTable.Td>14</MantineTable.Td>
          <MantineTable.Td>46.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>46</MantineTable.Td>
          <MantineTable.Td>31</MantineTable.Td>
          <MantineTable.Td>12</MantineTable.Td>
          <MantineTable.Td>13</MantineTable.Td>
          <MantineTable.Td>14.5</MantineTable.Td>
          <MantineTable.Td>47</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>46.5</MantineTable.Td>
          <MantineTable.Td>31.5</MantineTable.Td>
          <MantineTable.Td>12.5</MantineTable.Td>
          <MantineTable.Td>13.5</MantineTable.Td>
          <MantineTable.Td>15</MantineTable.Td>
          <MantineTable.Td>47.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>47</MantineTable.Td>
          <MantineTable.Td>32</MantineTable.Td>
          <MantineTable.Td>13</MantineTable.Td>
          <MantineTable.Td>14</MantineTable.Td>
          <MantineTable.Td>15.5</MantineTable.Td>
          <MantineTable.Td>48</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>47.5</MantineTable.Td>
          <MantineTable.Td>32.5</MantineTable.Td>
          <MantineTable.Td>13.5</MantineTable.Td>
          <MantineTable.Td>14.5</MantineTable.Td>
          <MantineTable.Td>16</MantineTable.Td>
          <MantineTable.Td>48.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>48</MantineTable.Td>
          <MantineTable.Td>33</MantineTable.Td>
          <MantineTable.Td>14</MantineTable.Td>
          <MantineTable.Td>15</MantineTable.Td>
          <MantineTable.Td>16.5</MantineTable.Td>
          <MantineTable.Td>49</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>48.5</MantineTable.Td>
          <MantineTable.Td>33.5</MantineTable.Td>
          <MantineTable.Td>14.5</MantineTable.Td>
          <MantineTable.Td>15.5</MantineTable.Td>
          <MantineTable.Td>17</MantineTable.Td>
          <MantineTable.Td>49.5</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>49</MantineTable.Td>
          <MantineTable.Td>34</MantineTable.Td>
          <MantineTable.Td>15</MantineTable.Td>
          <MantineTable.Td>16</MantineTable.Td>
          <MantineTable.Td>17.5</MantineTable.Td>
          <MantineTable.Td>50</MantineTable.Td>
        </MantineTable.Tr>
      </MantineTable.Tbody>
    </MantineTable>
  );
}
